// /client/src/components/FindClarity.js
import React from 'react';
import NavigationPdfs from './NavigationPdfs';
import FooterPdfs from './FooterPdfs';

const FindClarity = () => {
  return (
    <>
      <div className="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between">
        <div className='fullWidth'>
            <NavigationPdfs />
            <div className="pt-2 columns is-centered">
                <div className="column is-6-tablet is-5-desktop is-5-widescreen">
                    <div className="px-4 py-5">
                        <h1 className="h1 colorBlack is-bold">Find Clarity</h1>
                        <h2 className='h2 is-bold'>Introduction</h2>
                        <p className="pb-4 colorBlack">
                            In this chapter, we teach you how to use a tool that we refer to as the Spectrum of Knowing. This tool can be used anytime you are feeling unclear, unsure, or uncertain about something. It will help you find just enough clarity to begin taking action.
                        </p>
                        <p className="pb-4 colorBlack">
                            Click the download button below to view the optional reading. 
                        </p>
                        <div className="py-5 field">
                            <a 
                                href="/pdfs/next-move-find-clarity-v2.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button"
                                download
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <FooterPdfs />
      </div>
    </>
  );
};

export default FindClarity;